import { IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import Iconify from '../../../../components/iconify/iconify';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useState } from 'react';
import loginController from '../../controllers/login.controller';

const schema = yup.object({
  username: yup.string().required('ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້ງານ'),
  password: yup
    .string()
    .min(6, 'ລະຫັດຜ່ານຕ້ອງມີຢ່າງໜ້ອຍ 6 ຕົວອັກສອນ')
    .required('ກະລຸນາປ້ອນລະຫັດຜ່ານ'),
});

type LoginForm = yup.InferType<typeof schema>;

const Form = () => {
  const [showPassword, setShowPassword] = useState(false);
  const loginCtrl = loginController();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginForm>({ resolver: yupResolver(schema) });

  const onSubmit = (data: LoginForm) => {
    loginCtrl.handleSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={4}>
        <TextField
          label="ຊື່ຜູ້ໃຊ້ງານ"
          autoComplete="email"
          error={!!errors.username}
          helperText={errors.username?.message}
          {...register('username')}
        />

        <TextField
          label="ລະຫັດຜ່ານ"
          type={showPassword ? 'text' : 'password'}
          autoComplete="password"
          error={!!errors.password}
          helperText={errors.password?.message}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((v) => !v)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
          {...register('password')}
        />

        {loginCtrl.errorMessage ? (
          <Typography sx={{ color: 'red' }}>{loginCtrl.errorMessage}</Typography>
        ) : null}
      </Stack>

      <LoadingButton
        sx={{ mt: 7.5, borderRadius: 5 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        color="primary"
        loading={loginCtrl.loading}
      >
        ເຂົ້າສູ່ລະບົບ
      </LoadingButton>
    </form>
  );
};

export default Form;
